// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"e0e64036","355":"906135bd","484":"0cf08bcf","508":"1d6b4285","629":"313787bf","869":"96e33f60","974":"38fa62d1"}[chunkId] + ".chunk.js";
};